<template>
  <Dialog ref="savingDialog">
    <template #expander>
      <ButtonCustomized
        label="Save"
        @click="saveCampaign"
        :disabled="!hasUnsavedChanges"
      />
    </template>
    <template #dialog.title>Saving</template>
    <template #dialog.content="{closeModal, closeModalAfter}">
      <div class="saving-progress-dialog-content">
        <!-- TODO: think about adding height option for StatusBar — N2LBs3CL -->
        <StatusBar
          :errorMessage="errorMessage"
          :isLoading="isLoading"
          loadingMessage="Saving..."
          :isSuccess="isSuccess"
          successMessage="Saved!"
        />
      </div>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
// TODO: think about sharing logic with SavePlaylistButton
import ButtonCustomized from '@/components/form-fields/ButtonCustomized.vue';
import Dialog from '@/components/Dialog/Dialog.vue';
import StatusBar from "@/components/form-fields/StatusBar/StatusBar.vue";
import useNotifications from '@/components/Notifications/composables/notifications';
import useCampaign from '../composables/campaign';
import useSaveCampaignFormHelpers from "../composables/saveCampaignFormHelpers";
import { ref } from 'vue';

defineExpose({
  saveCampaign
})

const notification = useNotifications();
const { submitForm, isSuccess, errorMessage, isLoading } = useSaveCampaignFormHelpers();
const { hasUnsavedChanges, unsetHasUnsavedChanges} = useCampaign();

const savingDialog = ref();

async function saveCampaign() {
  savingDialog.value.openModal();
  await submitForm();
  if(isSuccess.value === true) {
    notification.success('Campaign saved successfuly!');
    unsetHasUnsavedChanges({resetDataInitializationState: false});
    savingDialog.value.closeModalAfter(1000);
  } else {    // on failure
    notification.failure('Campaign saving failed!');
  }
}
</script>

<style lang="scss" scoped>
.saving-progress-dialog-content {
  min-height: 60px;
  min-width: 300px;
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;
}
</style>